<template>
  <div :class="{'app-extra': $root.extra === true, 'app-init': $root.init === true, 'app-tray-active': this.$root.overlay, 'app-context-active': $root.contextOpen}" :data-project="$root.project" :style="$root.color ? `--color: rgb(${$root.color}); --colorRGB: ${$root.color}`: ''" id="app">
    <div class="nobook" v-if="$root.nobooks">
      <span>{{$root.project == "GTA" ? "gta-edition.ch" : "intercom-mono.ch"}}</span>
      No books available.
      <br>
      Please check again later.
    </div>
    <transition name="fade-delay">
      <div class="loading" v-if="$root.loading.do > 0">
        <div class="loading-icon"/>
      </div>
    </transition>
    <Navigation/>
    <router-view v-if="$root.mount === true" v-slot="{ Component }" :key="`${parseInt($route.params.bookId)}-${parseInt($route.params.bookIndex || 0)}`">
      <keep-alive>
        <component :is="Component" />
      </keep-alive>
    </router-view>
  </div>
</template>

<script>

import Navigation from './components/Navigation.vue'

export default {
  name: 'App',
  components: {
    Navigation
  }
}
</script>

<style lang="scss">
    @import 'main';
    .nobook {
      width: 20vw;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translateX(-50%)  translateY(-50%);
      padding: var(--padding);
      background: var(--title-background-color);
      color: var(--context-tray-font-color);
      span {
        font-size: var(--smallfont-fontsize);
        display: block;
        border-bottom: 1px solid;
        padding-bottom: var(--padding-05);
        margin-bottom: var(--padding-05);
      }
    }
    .loading {
      z-index: 5001;
      position: fixed;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      @include flex-vertical-center;
      backdrop-filter: blur(var(--padding-05));
      &-icon {
        width: var(--padding);
        height: var(--padding);
        &:after {
          content: "💤";
          position: absolute;
          display: block;
          animation: roti 3s linear infinite;
         font-size: var(--padding-20);
        }
      }
      @keyframes roti {
        0% {
            transform:rotate(0deg)
        }
        5% {
            transform:rotate(180deg)
        }
        50% {
            transform:rotate(180deg)
        }
        55% {
            transform:rotate(360deg)
        }
        to {
            transform:rotate(360deg)
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/App.vue